<template>
  <PageScroll
    class="-width-limiter-"
    :data="teamList"
    :is-loading="noMorePage"
    width="100%"
    @incrementPage="setPage"
  >
    <div class="ui-space-table__body-custom">
      <template v-if="isGroupLoading">
        <TeamDropdown v-for="i in 5" :key="i" :loading="true" size-title="l" />
      </template>
      <template v-else>
        <Team
          v-for="team in teamPagination"
          :key="team.id"
          class="-pointer-"
          :folder-team="team"
          :nav-titles="navTitles"
        />
      </template>
    </div>
  </PageScroll>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TeamDropdown from './TableDropdown';
import Team from './Team';

export default {
  components: {
    TeamDropdown,
    Team
  },
  props: {
    navTitles: {}
  },
  data: () => ({
    page: 0,
    limit: 20
  }),
  computed: {
    ...mapState('ratingTeams', {
      users: s => s.data.users,
      isGroupLoading: s => s.meta.isGroupLoading
    }),
    ...mapGetters('ratingTeams', {
      teamList: 'teamList'
    }),
    noMorePage() {
      return this.teamList.length === this.teamPagination.length;
    },
    teamPagination() {
      return this.teamList.slice(0, this.page * this.limit);
    }
  },
  mounted() {
    this.setPage();
  },
  methods: {
    setPage() {
      ++this.page;
    }
  }
};
</script>
